<template>
  <base-modal
    :reference="'editBusInfo_' + busId"
    :title="'Editar información operativa del bus'"
    :acceptAction="editBusInfo"
    :cancelActionText="'Cerrar'"
    :size="'md'"
  >
    <template v-slot:body v-if="show">
      
      <div class="d-block text-center">
        <form>
          <div class="d-flex justify-content-center w-100 mt-4">
            <div class="d-flex flex-column align-items-sm-baseline">
              <label>Nombre guia</label>
              <b-form-select
                v-model="bus.guideId"
                style="width: 17vw;"
              >
                <option :value="0">Seleccione un guía</option>
                <option
                  v-for="guide in guides"
                  :key="guide.id"
                  :label="guide.full_name"
                  :value="guide.id"
                >
                  {{ guide.full_name }}
                </option>
              </b-form-select>
            </div>
          </div>
          <div class="d-flex justify-content-center w-100 mt-4">
            <div class="d-flex flex-column align-items-sm-baseline">
              <label>Punto de recogida</label>
              <b-form-input
                v-model="bus.personPickupPoint"
                placeholder="Inserte punto de recogida del guía"
                style="width: 17vw; border: 1px solid #999 !important;"
                class="border-black border"
              ></b-form-input>
            </div>
          </div>
          <div class="d-flex justify-content-center w-100 mt-4">
            <div class="d-flex flex-column align-items-sm-baseline">
              <label>Hora de recogida</label>
              <b-form-input
                type="time"
                v-model="bus.personPickupHour"
                placeholder="Inserte hora de recogida del guía"
                style="width: 17vw; border: 1px solid #999 !important;"
              ></b-form-input>
            </div>
          </div>
          
          <div class="d-flex justify-content-center w-100 mt-4">
            <div class="d-flex flex-column align-items-sm-baseline">
              <label>Comentarios</label>
              <b-form-textarea
                v-model="bus.comment"
                placeholder="Inserte información para el chófer"
                style="width: 17vw; height: 150px; border: 1px solid #999 !important;"
              ></b-form-textarea>
            </div>
          </div>
        </form>
      </div>
    </template>

  </base-modal>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import BaseModal from '../../../Excursions/Booking/Modal/BaseModal';

export default {
  components: {
      BaseModal,
  },
  props: {
    busId: {
      type: Number, 
      required: true,
    }
  },
  data() {
    return {
      bus: {
        guideId: '',
        nameGuide: '',
        personPickupPoint: '',
        personPickupHour: '',
        comment: '',
      },
      show: false,
    }
  },
  async mounted() {
    this.$root.$on('bv::modal::show', async (bvEvent, modalId) => {
      

      if ( modalId === 'editBusInfo_' + this.busId ) {
        this.$store.dispatch("guides/retrieveGuides")
        
        console.log('mounted editbus')
        let bus = {}
        if ( this.activeTab === 'Excursions')
          bus = await this.$store.getters.idBusExcursionType(this.busId)
        else if ( this.activeTab === 'Pickups')
          bus = await this.$store.getters.idBusPickupType(this.busId)
        else if ( this.activeTab === 'Returns')
          bus = await this.$store.getters.idBusReturnType(this.busId)
        else
          console.error("activeTab unrecognized")

        this.bus = {
          guideId: bus.guide,
          nameGuide: '',
          personPickupPoint: bus.person_pickup_point,
          personPickupHour: bus.person_pickup_time,
          comment: bus.comment, 
        }
        this.show = true
      }
    })
  },
  methods: {
    async editBusInfo() {
      let id
      if ( this.$route.path == "/app/excursiones/excursiones" )
        id = this.$store.getters.idBusExcursionType(this.busId).id
      else if ( this.$route.path == "/app/excursiones/pickups" )
        id = this.$store.getters.idBusPickupType(this.busId).id
      else if ( this.$route.path == "/app/excursiones/returns" )
        id = this.$store.getters.idBusReturnType(this.busId).id

      let payload = {
        id: id,
        data: {
          guide: this.bus.guideId,
          person_name: this.$store.getters.guideById(this.bus.guideId).full_name,
          person_pickup_point: this.bus.personPickupPoint,
          person_pickup_time: this.personPickupHour == "" ? null : this.bus.personPickupHour,
          comment: this.bus.comment,
          bus_company: this.bus.busCompanyId,
          bus_fare_type: this.bus.busFareTypeId
        }
      };

      await this.$store.dispatch("buses/editBusInfo", payload)
        .then( (response) => {
          const busData = {
            date: this.$store.getters.filterDate,
            group: this.$store.getters.filterGroup,
            bus_type:
              this.$route.path == "/app/excursiones/excursiones" ? "Excursion" : "Pickup"
          };

          this.$bvModal.hide('editBusInfo_' + this.busId);

          this.$notify({
            group: "foo",
            title: "Bus editado",
            text: "Se ha editado la información del bus",
            type: "success"
          });

          if ( this.activeTab === 'Excursions')  
            this.$store.dispatch("buses/loadExcursionBuses")
          else if ( this.activeTab === 'Pickups')
            this.$store.dispatch("buses/loadPickupBuses")
          else if ( this.activeTab === 'Returns')
            this.$store.dispatch("buses/loadReturnBuses")
        })
        .catch( (error) => {
          console.log(error)
          this.$notify({
              group: "foo",
              title: "Error en los datos",
              text: "Por favor, revise los datos",
              type: "error"
            });
        })

      
    },
  },
  computed: {
    ...mapGetters(["activeTab", "guides", "busCompanies", "busFareTypes"])
  }
};
</script>
